import { Auth } from 'aws-amplify';

const environment = {
    production: false,
    debug: false,
    offline: false,
    cloudformationLaunchStackUrl: 'https://console.aws.amazon.com/cloudformation/home?region=eu-west-1#/stacks/create/review?stackName=VizCon&templateURL=https://vizcon-resources-dev.s3.amazonaws.com/iac/latest/crossAccountAccessRole.yml',
    cloudformationTemplateUrl: 'https://resources.dev.vizcon.cloud/iac/latest/crossAccountAccessRole.yml',
    cognitoSelfSignUpEnabled: true,
    Amplify: {
        Auth: {
            region: 'eu-west-1',
            userPoolId: 'eu-west-1_y8Rb5SEJW',
            userPoolWebClientId: '4smbqnrbaavtn7ikbfvn5ong2c',
        },
        API: {
            endpoints: [
                {
                    name: 'VizConAPI',
                    endpoint: 'https://api.dev.vizcon.cloud',
                    custom_header: async () => {
                        return { Authorization: (await Auth.currentSession()).getIdToken().getJwtToken() };
                    }
                }
            ]
        }
    },
    features: {
        subscriptions: true,
        userInvitation: false
    },
    stripe: {
        enabled: true,
        "redirectUrl": "https://app.dev.vizcon.cloud"
    },
    aws: {
        enabled: true,
        marketplaceUrl: "https://aws.amazon.com/marketplace/pp/prodview-qxc4uvwkmnmbu",
        marketplaceUrlSubscription: "https://aws.amazon.com/marketplace/pp/prodview-myrfxs5hkddfc",
        subscriptionManagementUrl: "https://console.aws.amazon.com/marketplace/subscriptions",
        productCode: "z7gq5i3k5a8crrnfo7rdxt7q",  // Lifetime product code
        productCodeSubscription: "2sgump2wc6meyfebxuz5jqxvw"  // Subscription product code (monthly/yearly)
    },
    defaultRoleName: "vizconDev",
    matomo: {
        enabled: true,
        containerUrl: "https://cdn.matomo.cloud/mksolutions.matomo.cloud/container_SAWB52y7.js"
    },
    branding: {
        logoPath: "assets/img/logo/vizcon-logo.png",
        logoAlt: "VizCon Logo",
        companyName: "VizCon DEV"
    },
    license: {
        expiryDate: null,  // Optional: ISO date string (e.g., "2024-12-31T23:59:59Z") for POC/trial licenses
        warningDays: 7     // Show warning X days before expiry
    }
};

export default environment;
